import React from 'react';
import PropTypes from 'prop-types';
import dataAids from '../../constants/dataAids';
import ViewAllLink from './ViewAllLink';

const BottomLinks = ({
  translate,
  productsLength,
  renderMode,
  shopWidgetSamePage,
  shopWidgetPageId,
  shopWidgetRoute,
  handleClickViewAll
}) => {
  if (shopWidgetPageId && productsLength > 0) {
    const dataAid = dataAids.PRODUCT_GROUP_VIEW_ALL;

    const baseProps = {
      'href': `${shopWidgetRoute}/ols/products`,
      'onClick': handleClickViewAll,
      'data-page-query': 'olsPage=products',
      'data-page': shopWidgetPageId
    };

    return (
      <ViewAllLink
        baseProps={ baseProps }
        shopWidgetSamePage={ shopWidgetSamePage }
        renderMode={ renderMode }
        translate={ translate }
        data-aid={ dataAid }
      />
    );
  }
  return null;
};

BottomLinks.propTypes = {
  translate: PropTypes.func,
  productsLength: PropTypes.number,
  renderMode: PropTypes.string,
  shopWidgetSamePage: PropTypes.bool,
  shopWidgetPageId: PropTypes.any,
  shopWidgetRoute: PropTypes.any,
  handleClickViewAll: PropTypes.func
};

export default BottomLinks;
